import { BaseService } from 'services/baseService';
import { PositionModel } from 'types/models/PositionModel';

class PositionService extends BaseService<PositionModel> {
  controllerName = 'positions';
}

export const positionService = new PositionService();
